import { render, staticRenderFns } from "./Aliplayer.vue?vue&type=template&id=7f82c19d&scoped=true"
import script from "./Aliplayer.vue?vue&type=script&lang=js"
export * from "./Aliplayer.vue?vue&type=script&lang=js"
import style0 from "./Aliplayer.vue?vue&type=style&index=0&id=7f82c19d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f82c19d",
  null
  
)

export default component.exports